const stringToColor = (str = '') => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
    let color = '#';
    for (let i = 0; i < 3; i++) color += (`00${((hash >> (i * 8)) & 0xFF).toString(16)}`).slice(-2);
    return color;
};

const pharmacyInitials = (name = '') => {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
};

// Same circular, colored-initials style as the Confrères listing — kept as a
// shared component so both places stay in sync.
const PharmacyAvatar = ({ pharmacy, size = 45 }) => {
    const name = pharmacy?.name || '';
    const bg = stringToColor(name);

    return (
        <div style={{
            padding: 2, width: size, height: size, flexShrink: 0,
            border: '1px solid #e5e7eb', borderRadius: '50%',
            background: '#f9fafb',
        }}>
            <div style={{
                width: '100%', height: '100%', borderRadius: '50%',
                background: bg, color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 700, fontSize: Math.round(size * 0.34), letterSpacing: '0.03em',
            }}>
                {pharmacyInitials(name)}
            </div>
        </div>
    );
};

export default PharmacyAvatar;
